import store from '../store'
import Api from './Api'

class Auth {
	constructor() {
		this.host = process.env.VUE_APP_API_ORIGIN;
		this.api = new Api()
	}

	async login(loginId, password) {
		await this.api.post('staffs/login', { "login_id": loginId, "password": password })
			.then((res) => {
				store.commit('basic', {
					key: 'auth',
					value: res.data,
				})
			})
			.catch((error) => {
				throw new Error(error.response.status);
			}
		);
	}

	logout() {
		store.commit('basic', {
			key: 'auth',
			value: null,
		});
	}

	get user() {
		return store.state.auth;
	}

	get token() {
		return store.state.auth.token;
	}

	get isLoggedIn() {
		return store.state.auth !== null;
	}
}

export default Auth
